// extracted by mini-css-extract-plugin
export default {"button":"toggleButton_button__z36R5","active":"toggleButton_active__+oJk4"};